import React from 'react';
import {
  Create,
  SimpleForm,
  FileInput,
  ImageField,
  useCreate,
  useNotify,
  useRedirect,
  Toolbar,
  SaveButton,
  required
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { uploadImage } from '../../../config/services/strapi/strapi';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';

const MediaPreview = ({ record }: { record?: any }) => {
  if (!record) return null;
  const isVideo = record.rawFile?.type.includes('video') || record.url?.endsWith('.mp4');
  const src = record.src || record.url;

  return isVideo ? (
    <video controls width="300" style={{ borderRadius: '8px', marginTop: '10px' }}>
      <source src={src} type={record.rawFile?.type || 'video/mp4'} />
    </video>
  ) : (
    <ImageField source="src" title="title" />
  );
};

function QuienesSomosCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'plg-quienes-somoss';

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      if (!data.videoUrl?.rawFile) {
        notify('El archivo multimedia es obligatorio', { type: 'warning' });
        return;
      }

      const fileUploaded = await uploadImage(data.videoUrl.rawFile, token!);
      const payload = {
        descripcion: data.descripcion,
        videoUrl: { id: fileUploaded.id },
      };

      create(resourceName, { data: payload }, {
        onSuccess: () => {
          notify('Creado con éxito', { type: 'success' });
          redirect('list', resourceName);
        }
      });
    } catch (e) {
      notify('Error al crear', { type: 'error' });
    }
  };

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <RichTextInput 
          source="descripcion" 
          label="Descripción"
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />
        <FileInput source="videoUrl" label="Video de cabecera" validate={[required()]}>
          <MediaPreview />
        </FileInput>
      </SimpleForm>
    </Create>
  );
}

export default QuienesSomosCreate;